import React from 'react';

export const languages = {
  'en-US': {label: 'general.language.english', time: 'en'},
  'fr-CA': {label: 'general.language.french', time: 'fr-ca'},
};


export function getLanguageFromLocale(locale) {
  if(!locale || locale.lenght < 2) {
    return 'EN';
  }
  return  locale.substr(0,2).toUpperCase();
}

export function getTranslatedAssetFileName({filename, ext, language}) {
  language = language || 'EN';
  ext = ext || '';
  ext = ext && ext.indexOf('.') !== 0 ? `.${ext}` : ext; //if there is an extension without dot add dot.
  //Default language is english, so we don't need any special identifier for the file

  if(language === 'EN') {
    return `${filename}${ext}`;
  }
  return `${filename}-${language}${ext}`; //ie: -FR
}


export const allowTranslations = true;
